import { z } from "zod";
import { MetaSchema } from "./shared";
import {
  DepositTokenNameEnum,
  DepositTokenTypeEnum,
  PlatformMainServicesEnum,
  TransactionTypeEnum,
} from "../enums";

export const WalletDepositInvestPlanSchema = z.object({
  id: z.string().uuid(),
  count: z.union([z.string(), z.number()]).optional().nullable(),
  price: z.union([z.string(), z.number()]).optional().nullable(),
});

export const WalletDepositBodySchema = z.object({
  amount: z.number(),
  value: z.number(),
  coin: DepositTokenNameEnum.depositTokenNameSchema,
  type: DepositTokenTypeEnum.depositTokenTypeSchema,
  investPlans: z.array(WalletDepositInvestPlanSchema).optional(),
  platform: PlatformMainServicesEnum.platformMainServicesSchema.optional(),
  useGGold: z.number().optional(),
  useProfit: z.number().optional(),
  refCode: z.string().optional(),
  transactionType: TransactionTypeEnum.transactionSchema.optional(),
  hash: z.string().nullable().optional(),
  count: z.string().nullable().optional().or(z.number().nullable().optional()),
});

export const WalletDepositUserSchema = z.object({
  id: z.string().uuid(),
});

export const WalletDepositWalletSchema = z.object({
  id: z.string().uuid(),
  investAmount: z.string(),
  balance: z.string(),
  equityBalance: z.string(),
  gGold: z.string(),
  dailyProfit: z.string(),
  profitCanWithdraw: z.string(),
  matchingReward: z.string(),
  address: z.string(),
  createdAt: z.string(),
  investUpdatedAt: z.string().optional().nullable(),
});

export const WalletDepositDataSchema = z.object({
  amount: z.string(),
  user: WalletDepositUserSchema,
  transaction_type: z.string(),
  status: z.string(),
  wallet: WalletDepositWalletSchema,
  coin: z.string(),
  useGGold: z.number().nullable().optional(),
  useProfit: z.number().nullable().optional(),
  type: z.string(),
  value: z.string(),
  created_at: z.string(),
  hash: z.string().nullable(),
  tracerKey: z.string().nullable(),
  completedAt: z.string().nullable(),
  description: z.string().nullable(),
  id: z.string().uuid(),
  fee: z.string(),
});

const WalletDepositResponse = z.object({
  data: WalletDepositDataSchema,
  meta: MetaSchema.default,
});

export default WalletDepositResponse;

export type WalletDepositBodyType = z.infer<typeof WalletDepositBodySchema>;

export type WalletDepositResponseType = z.infer<typeof WalletDepositResponse>;
